import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["demoData"];
var _templateObject;
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { styled, keyframes, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PageContext from 'docs/src/modules/components/PageContext';
import { createMuiChat } from '../sandbox/MuiChat';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var rainbow = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    background-position: -100% center;\n  }\n  100% {\n    background-position: 100% center;\n  }\n"])));
var RainbowButton = styled(Button)(function (_ref) {
  var theme = _ref.theme;
  return _extends({
    '--color-1': '0 100% 50%',
    '--color-2': '270 100% 50%',
    '--color-3': '210 100% 50%',
    '--color-4': '195 100% 50%',
    '--color-5': '90 100% 50%',
    position: 'relative',
    display: 'inline-flex',
    height: 26,
    padding: '7px 8px 8px 8px',
    // 7px for optical alignment
    flexShrink: 0,
    borderRadius: 999,
    border: '1px solid transparent',
    borderBottomWidth: '2.5px',
    borderColor: alpha(theme.palette.grey[200], 0.8),
    '&.MuiButton-loading': {
      '& > svg': {
        transform: 'translateX(36px)'
      }
    },
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    backgroundSize: '200%',
    backgroundClip: 'padding-box, border-box, border-box',
    backgroundOrigin: 'border-box',
    animation: "".concat(rainbow, " 2s linear infinite"),
    '--bg-color-raw': '255,255,255',
    '--bg-color': 'rgb(var(--bg-color-raw))',
    backgroundImage: "linear-gradient(var(--bg-color), var(--bg-color)), linear-gradient(var(--bg-color) 50%, rgba(var(--bg-color-raw)) 80%, rgba(var(--bg-color-raw), 0)), linear-gradient(90deg, hsl(var(--color-1)), hsl(var(--color-5)), hsl(var(--color-3)), hsl(var(--color-4)), hsl(var(--color-2)))",
    '&:hover': {
      '--bg-color-raw': '235,245,255'
    }
  }, theme.applyDarkStyles({
    '--bg-color-raw': '16, 18, 20',
    borderColor: alpha(theme.palette.primary[300], 0.2),
    '&:hover': {
      '--bg-color-raw': '13, 38, 63'
    }
  }), {
    '&::before': _extends({
      content: '""',
      position: 'absolute',
      bottom: '-25%',
      left: '50%',
      zIndex: 0,
      height: '20%',
      width: '60%',
      transform: 'translateX(-50%)',
      animation: "".concat(rainbow, " 3s linear infinite"),
      background: 'linear-gradient(90deg, hsl(var(--color-1)), hsl(var(--color-5)), hsl(var(--color-3)), hsl(var(--color-4)), hsl(var(--color-2)))',
      filter: 'blur(1.2rem)'
    }, theme.applyDarkStyles({
      width: '90%',
      filter: 'blur(0.5rem)'
    })),
    '& > svg': {
      height: 18,
      width: 18,
      margin: '0 4px 0 0',
      stroke: (theme.vars || theme).palette.primary.main,
      fill: (theme.vars || theme).palette.primary.main,
      transition: 'transform 0.4s'
    }
  });
});
var OpenInMUIChatButton = /*#__PURE__*/React.forwardRef(function OpenInMUIChatButton(_ref2, ref) {
  var demoData = _ref2.demoData,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var _React$useContext = React.useContext(PageContext),
    productId = _React$useContext.productId;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    error = _React$useState4[0],
    setError = _React$useState4[1];
  var baseUrl = process.env.MUI_CHAT_API_BASE_URL;
  var scopes = process.env.MUI_CHAT_SCOPES;
  var handleClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            setError(null);
            _context.prev = 2;
            _context.next = 5;
            return createMuiChat(demoData).openSandbox();
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            setError(_context.t0);
          case 10:
            _context.prev = 10;
            setLoading(false);
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 7, 10, 13]]);
    }));
    return function handleClick() {
      return _ref3.apply(this, arguments);
    };
  }();

  // If the base URL is not set, we can't render the button
  if (!baseUrl || !scopes || !scopes.split(',').includes(productId)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(RainbowButton, _extends({
      "data-mui-color-scheme": "dark",
      ref: ref,
      loading: loading,
      disabled: !!error,
      loadingIndicator: /*#__PURE__*/_jsx(CircularProgress, {
        color: "inherit",
        size: 12
      }),
      onClick: handleClick
    }, props, {
      children: [/*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        children: /*#__PURE__*/_jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
        })
      }), ' ', "Edit in Chat"]
    })), /*#__PURE__*/_jsx(Snackbar, {
      open: !!error,
      color: "error",
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      onClose: function onClose() {
        return setError(null);
      },
      autoHideDuration: 6000,
      children: /*#__PURE__*/_jsx(Alert, {
        onClose: function onClose() {
          return setError(null);
        },
        severity: "error",
        sx: {
          width: '100%'
        },
        children: (error == null ? void 0 : error.message) || 'Failed to open in MUI Chat'
      })
    })]
  });
});
if (false) OpenInMUIChatButton.displayName = "OpenInMUIChatButton";
export default OpenInMUIChatButton;